import { IRetailPoint } from '~/src/api/content/retail-point';

import Content from './components/Content/index';
import Header from './components/Header/index';
import Map from './components/Map/index';

import * as ST from './styled';

interface IProps {
    contacts: IRetailPoint[],
}

const Contact = ({ contacts }: IProps) => {
    return (
        <ST.Wrapper>
            <Header/>
            <Content/>
            <Map contacts={contacts} />
        </ST.Wrapper>
    );
};

export default Contact;
